export default {
  fromGerenteRelacionamentoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  toGerenteRelacionamentoId: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/movimentacoes/changeMassGerenteRelacionamento/link-form.js